import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ error }) => (
  <>
    <p>{error[0].toUpperCase() + error.slice(1, error.length)}</p>
    <style jsx>
      {`
        p {
          margin: 5px 0px;
          font-size: 0.9em;
          line-height: 21px;
          text-align: left;
          color: red;
        }
      `}
    </style>
  </>
);

Error.propTypes = {
  error: PropTypes.string.isRequired,
};

export default Error;